import { RichMentionsInput } from '@flatfile/baseline'
import React from 'react'
import { MentionsPopover } from '../Mentions/MentionsPopover'
import { MentionsWrapper } from '../Mentions/MentionsWrapper'

interface MentionInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  autoFocus?: boolean
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void
}

export function MentionInput({
  value,
  onChange,
  placeholder = 'Enter your prompt...',
  autoFocus = false,
  onKeyDown,
}: MentionInputProps) {
  function processMentionsWithCurlyBraces(htmlContent: string): string {
    // Create a temporary DOM element to work with
    const tempElement = document.createElement('div')
    tempElement.innerHTML = htmlContent

    // Find all spans with data-rich-mentions attribute (created by RichMentions)
    const mentionSpans = tempElement.querySelectorAll(
      'span[data-rich-mentions]'
    )

    // Process each span and replace it with its encoded mention value wrapped in curly braces
    mentionSpans.forEach((span) => {
      // Get the ref from data-rich-mentions attribute (which now contains the full encoded mention)
      const encodedMention = span.getAttribute('data-rich-mentions')

      if (encodedMention) {
        // Create a text node with the encoded mention wrapped in curly braces
        const textNode = document.createTextNode(`{${span.textContent}}`)
        span.parentNode?.replaceChild(textNode, span)
      }
    })

    // Get the processed text content
    const result = tempElement.innerText

    return result
  }

  function handleInput(event: React.FormEvent<HTMLDivElement>) {
    const processedValue = processMentionsWithCurlyBraces(
      event.currentTarget.innerHTML
    )
    onChange(processedValue)
  }

  function handleKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    if (onKeyDown) onKeyDown(event)
    if (event.key === 'Escape') {
      event.currentTarget.blur()
    }
  }

  return (
    <MentionsWrapper>
      <div className='relative'>
        <div className='flex items-center gap-3 px-3 py-2 bg-[#f8f9fa] rounded-lg min-h-[40px]'>
          <RichMentionsInput
            value={value}
            defaultValue={value}
            autoFocus={autoFocus}
            className='flex-1 text-sm text-[#1b1b1e] placeholder-[#838383] bg-transparent border-none outline-none min-h-[20px]'
            placeholder={placeholder}
            disabled={false}
            onKeyDown={handleKeyDown}
            onInput={handleInput}
            spellCheck={false}
            style={{
              lineBreak: 'anywhere',
            }}
          />
        </div>
        <MentionsPopover />
      </div>
    </MentionsWrapper>
  )
}
